export const LANGUAGE = {
  en: 'English',
  'zh-cn': '中文(简体)',
  'zh-Hans': '',
  'zh-Hant': '中文(繁体)',
  'zh-tc': '',
  ja: '日本語',
  ko: ' 한국어',
  th: 'ภาษาไทย',
  it: 'Italiano',
  in: 'Indonesia',
  id: '',
  es: 'Español',
  ru: 'Русский',
  de: 'Deutsch',
  fr: 'Français',
  pt: 'Português'
};
export const LANGUAGE_NAME = {
  en: '英文',
  'zh-cn': '简体中文',
  'zh-Hans': '简体中文',
  'zh-Hant': '繁体中文',
  'zh-tc': '繁体中文',
  ja: '日语',
  ko: '韩语',
  th: '泰语',
  it: '意大利语',
  in: '印度尼西亚语',
  id: '印度尼西亚语',
  es: '西班牙',
  ru: '俄语',
  de: '德语',
  fr: '法语',
  pt: '葡萄牙语'
};
export const XIGUA_LANGUAGE = {
  en: 'en',
  'zh-cn': 'zh-Hans',
  'zh-Hans': 'zh-Hans',
  'zh-tc': 'zh-Hant',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  it: 'it',
  id: 'in',
  es: 'es',
  ru: 'ru',
  de: 'de',
  fr: 'fr',
  'zh-Hant': 'zh-Hant',
  in: 'in',
  pt: 'pt'
};

export const ZT_LANGUAGE = {
  en: 'en',
  'zh-cn': 'zh-Hans',
  'zh-Hans': 'zh-Hans',
  'zh-tc': 'zh-Hant',
  ja: 'jp',
  ko: 'kor',
  th: 'th',
  it: 'it',
  id: 'id',
  es: 'spa',
  ru: 'ru',
  de: 'de',
  fr: 'fra',
  'zh-Hant': 'zh-Hant',
  in: 'id',
  pt: 'pt'
};

/**
 *
 * zho（简体中文）
 * eng（英文）
 * zho-tw（台湾）
 * zho-hk（香港）
 * udm（维吾尔语）
 * jpn（日文）
 * ind（印尼）
 * kor（韩语）
 * rus（俄语）
 * ara（阿拉伯语）
 * spa（西班牙语）
 * pon（巴西葡语）
 * por（欧洲葡语）
 * fra（法语）
 * deu（德语）
 * @type {{de: string, 'zh-HANT': string, ru: string, ko: string, th: string, ja: string, en: string, it: string, id: string, fr: string, es: string}}
 */
export const GEETEST_LANGUAGE = {
  en: 'eng',
  'zh-cn': 'zho',
  'zh-Hans': 'zho',
  'zh-tc': 'zho-hk',
  ja: 'jpn',
  ko: 'kor',
  th: 'eng',
  it: 'eng',
  id: 'ind',
  es: 'spa',
  ru: 'rus',
  de: 'deu',
  fr: 'fra',
  'zh-Hant': 'zho-hk',
  in: 'ind',
  pt: 'por'
};
